import styled from "styled-components";

const BadgeSmallBase = styled.span.attrs({ className: "badge badge--small" })`
  border-radius: 100px;
  color: ${props => props.theme.colors.white};
  height: 18px;
  text-align: center;
  width: 23px;

  &.badge--floating {
    border-radius: 50%;
    position: absolute;
    right: 0;
    top: -10px;
    width: 18px;
  }
`;

BadgeSmallBase.displayName = "BadgeSmallBase";

export default BadgeSmallBase;
